import React, { Component } from 'react';
import './Counter.scss';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.counterValue = this.counterValue.bind(this);
    this.startCounterInterval = this.startCounterInterval.bind(this);
    this.state = {
      counter: this.props.counterValue,
    };
    this.startCounterInterval();
  }

  componentWillUnmount() {
    clearInterval(this.counterInterval);
  }

  startCounterInterval() {
    this.counterInterval = setInterval(() => {
      if (this.state.counter <= 0) {
        clearInterval(this.counterInterval);
        setTimeout(this.props.showhideCounter, 500);
      } else {
        this.setState({ counter: this.state.counter - 1 });
      }
    }, 1000);
  }

  counterValue(value) {
    if (!isNaN(value)) {
      value = Math.floor(value);
      if (value >= 0 && value < 10) {
        return `0${value}`;
      }
      return `${value}`;
    }
    return '';
  }

  render() {
    const { counter } = this.state;
    const {
      dataLocale: { SEND_YOURSELF_OTP, SEC },
    } = this.props;
    if (this.props.newStyle) {
      return (
        <div className="new-style-font animate-left-login-screen">
          <span className="new-style-dark">Resend OTP in</span>
          <span className="new-style-light">&nbsp;{this.counterValue(counter / 60)}</span>:
          <span className="new-style-light">&nbsp;{this.counterValue(counter % 60)}</span>
          <span className="new-style-light">&nbsp;</span>
          <span className="new-style-light">{SEC}</span>
        </div>
      );
    }

    return (
      <div className="counter">
        <span className="block text-center mr-b5">
          {SEND_YOURSELF_OTP}
          <span>&nbsp;{this.counterValue(counter / 60)}</span>:
          <span>&nbsp;{this.counterValue(counter % 60)}</span>
          <span>&nbsp;</span>
          <span>{SEC}</span>
        </span>
      </div>
    );
  }
}

export default Counter;
